import { Component, OnInit } from '@angular/core';
import {CURRENT_RELEASE_VERSION, FOOTER_TEXT} from "../../common/Constants";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footerText = FOOTER_TEXT;
  currentReleaseVersion = CURRENT_RELEASE_VERSION;

  constructor() { }

  ngOnInit(): void {
  }

}
